module.exports = __webpack_public_path__ + "img/product23.4beb75c9.png";